import { render, staticRenderFns } from "./ReceiveArchive.vue?vue&type=template&id=003b1dd8&"
import script from "./ReceiveArchive.vue?vue&type=script&lang=js&"
export * from "./ReceiveArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports